import { useEffect, useState } from 'react';
import { Button } from '@skupreme/shared/ui';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormInputSuffix, MaskedNumberFormField } from '@elements/FormField';
import { ToastMessage } from '@utility/toast';
import { ErrorMessageConstant } from '@utility/constants/common';
import { LoaderBar } from '@components/LoaderBar';
import PurchaseOrdersService from '@utility/services/purchase-order';
import { AppModal } from '@elements/Modal';

const leadTimeSchema = yup.object().shape({
  lead_time: yup.number().required().positive(),
});
export function LeadTimePopup({ open, closeModal, poId, item }) {
  const [saving, setSaving] = useState('');
  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm({
    resolver: yupResolver(leadTimeSchema),
    shouldUnregister: true,
  });

  useEffect(() => {
    if (open && item?.item_upc) {
      reset({
        lead_time: item?.lead_time,
      });
    } else {
      reset({});
    }
  }, [open, item]);

  const onSubmit = async formData => {
    try {
      const bodyData = {
        items: [
          {
            item_upc: item.item_upc,
            lead_time: formData.lead_time,
          },
        ],
      };
      setSaving('Saving');
      await PurchaseOrdersService.updateItemLeadTime(poId, bodyData);

      ToastMessage.success('Lead Time has been updated successfully.');
      closeModal(formData.lead_time);
    } catch (error) {
      ToastMessage.error(error.error || ErrorMessageConstant.defaultAPIError);
    } finally {
      setSaving('');
    }
  };

  return (
    <AppModal
      open={open}
      size="mini"
      title="Edit Lead Time"
      closeModal={() => closeModal()}
    >
      {saving && <LoaderBar content={saving} />}
      <form
        autoComplete="off"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        className="sk:flex sk:flex-col"
      >
        <MaskedNumberFormField
          error={errors.lead_time}
          label="Lead Time"
          name="lead_time"
          required
          control={control}
          inputRight={<FormInputSuffix>Days</FormInputSuffix>}
          defaultValue={null}
        />
        <div className="sk:flex sk:justify-end sk:gap-2">
          <Button onPress={() => closeModal()}>Cancel</Button>
          <Button type="submit" variant="primary">
            Update
          </Button>
        </div>
      </form>
    </AppModal>
  );
}
